module.exports = __webpack_public_path__ + "static/media/growslab_for_cherry_tomato_blog.4b0fb46e.webp";